/* tslint:disable */

import React from 'react';

interface IFerryIconProps {
    height: string;
    isWithoutBox: boolean;
}

const ferryIcon: React.SFC<IFerryIconProps> = props => {
    const icon = (
        <svg
            className='line-icon'
            version='1.1'
            id='Layer_1'
            x='0px'
            y='0px'
            viewBox='0 0 1024 1024'
            enableBackground='new 0 0 20 20'
            height={props.height}
        >
            <g>
                <path
                    fill='#00b9e4'
                    className='path1 fill-color14'
                    d='M870.393 993.287h-716.811c-67.864 0-122.883-55.015-122.883-122.883v-716.811c0-67.864 55.015-122.883 122.883-122.883h716.811c67.864 0 122.883 55.015 122.883 122.883v716.811c0 67.868-55.015 122.883-122.883 122.883z'
                />
                <path
                    fill='rgb(255, 255, 255)'
                    d='M961.666 962.822c17.708 0 32.198 12.882 32.198 30.594 0 17.708-14.49 30.591-32.198 30.591h-898.429c-16.101 0-30.591-12.882-30.591-30.591 0-17.712 14.49-30.594 30.591-30.594h898.429zM866.672 912.912h-713.274l-35.421-305.918c0 0 128.807-33.809 215.753-53.133 77.282-16.101 169.058-27.372 175.499-27.372s99.824 11.271 175.495 27.372c86.946 19.32 215.753 53.133 215.753 53.133l-33.806 305.918zM196.874 524.882v-223.805c0-28.979-8.052-67.622 67.622-67.622h140.082v-210.92c1.611-11.271 9.66-20.931 20.931-22.542h167.45c11.271 1.611 20.931 11.271 20.931 22.542v210.92h140.082c75.671 0 67.622 38.643 67.622 67.622v223.802c-43.469-11.271-77.282-19.32-136.86-32.202-77.282-16.101-170.665-27.372-175.495-28.983-4.834 1.611-98.217 12.882-175.499 28.983l-136.867 32.205zM290.257 350.991c0 33.809 25.761 59.574 59.574 59.574 33.809 0 59.57-25.761 59.57-59.574s-25.761-59.574-59.57-59.574c-33.809 0-59.574 25.761-59.574 59.574zM449.655 350.991c0 33.809 27.372 59.574 59.574 59.574 33.809 0 59.57-25.761 59.57-59.574s-25.761-59.574-59.57-59.574c-32.198 0-59.574 25.761-59.574 59.574zM609.057 350.991c0 33.809 27.372 59.574 59.57 59.574 33.813 0 59.574-25.761 59.574-59.574s-25.761-59.574-59.574-59.574c-32.198 0-59.57 25.761-59.57 59.574z'
                />
            </g>
        </svg>
    );

    const iconWithoutBox = (
        <svg
            className='line-icon'
            version='1.1'
            id='Layer_1'
            x='0px'
            y='0px'
            viewBox='0 0 1024 1024'
            enableBackground='new 0 0 16 16'
            height={props.height}
        >
            <g>
                <path
                    fill='#FFFFFF'
                    d='M961.666 962.822c17.708 0 32.198 12.882 32.198 30.594 0 17.708-14.49 30.591-32.198 30.591h-898.429c-16.101 0-30.591-12.882-30.591-30.591 0-17.712 14.49-30.594 30.591-30.594h898.429zM866.672 912.912h-713.274l-35.421-305.918c0 0 128.807-33.809 215.753-53.133 77.282-16.101 169.058-27.372 175.499-27.372s99.824 11.271 175.495 27.372c86.946 19.32 215.753 53.133 215.753 53.133l-33.806 305.918zM196.874 524.882v-223.805c0-28.979-8.052-67.622 67.622-67.622h140.082v-210.92c1.611-11.271 9.66-20.931 20.931-22.542h167.45c11.271 1.611 20.931 11.271 20.931 22.542v210.92h140.082c75.671 0 67.622 38.643 67.622 67.622v223.802c-43.469-11.271-77.282-19.32-136.86-32.202-77.282-16.101-170.665-27.372-175.495-28.983-4.834 1.611-98.217 12.882-175.499 28.983l-136.867 32.205zM290.257 350.991c0 33.809 25.761 59.574 59.574 59.574 33.809 0 59.57-25.761 59.57-59.574s-25.761-59.574-59.57-59.574c-33.809 0-59.574 25.761-59.574 59.574zM449.655 350.991c0 33.809 27.372 59.574 59.574 59.574 33.809 0 59.57-25.761 59.57-59.574s-25.761-59.574-59.57-59.574c-32.198 0-59.574 25.761-59.574 59.574zM609.057 350.991c0 33.809 27.372 59.574 59.57 59.574 33.813 0 59.574-25.761 59.574-59.574s-25.761-59.574-59.574-59.574c-32.198 0-59.57 25.761-59.57 59.574z'
                />
            </g>
        </svg>
    );

    return props.isWithoutBox ? iconWithoutBox : icon;
};

export default ferryIcon;
